import type { Movie } from '@/types';

export const categories = ['全部', '动作片', '爱情片', '科幻片', '喜剧片', '悬疑片', '剧情片', '奇幻片', '冒险片', '惊悚片'];

export const regions = ['全部', '中国大陆', '美国', '中国香港', '日本', '韩国', '英国', '法国', '印度'];

export const years = ['全部', '2026', '2025', '2024', '2023', '2022', '2021', '2020及更早'];

export const ratingOptions = ['全部', '9分以上', '8分以上', '7分以上', '6分以上'];

export const sortOptions = ['最新上映', '评分最高', '热门程度'];

export const movies: Movie[] = [
  {
    id: '1',
    title: '星际隧道',
    titleEn: 'Interstellar Tunnel',
    subtitle: '穿越时空尽头，人类最后的远航',
    category: '科幻片',
    genres: ['科幻', '冒险', '剧情'],
    year: 2026,
    region: '美国',
    rating: 8.9,
    duration: 148,
    director: '诺兰·卡特',
    cast: ['陈默', '艾米莉·沃森', '张远', '罗伯特·凯恩'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20lone%20astronaut%20silhouette%20before%20a%20glowing%20wormhole%20tunnel%20in%20deep%20space%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20elegant%20high-end%20key%20art&width=400&height=600&seq=movie-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20movie%20still%2C%20a%20glowing%20wormhole%20tunnel%20in%20deep%20space%20with%20a%20tiny%20spaceship%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20epic%20composition&width=1280&height=720&seq=movie-backdrop-01&orientation=landscape',
    synopsis:
      '一支由地球顶尖科学家组成的深空远征队，穿越一个神秘虫洞，去寻找人类新的家园。当时间与空间的法则被彻底打破，他们必须在宇宙尽头做出改变整个人类命运的选择。',
    featured: true,
    popularity: 98,
  },
  {
    id: '2',
    title: '暗夜追凶',
    titleEn: 'Night Pursuit',
    subtitle: '雨夜之下，真相只有一个',
    category: '动作片',
    genres: ['动作', '犯罪', '悬疑'],
    year: 2025,
    region: '中国香港',
    rating: 8.5,
    duration: 122,
    director: '杜峰',
    cast: ['刘振宇', '林嘉欣', '古天蓝', '周敏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20lone%20detective%20running%20through%20a%20rain-soaked%20neon%20city%20street%20at%20night%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20gritty%20crime%20key%20art&width=400&height=600&seq=movie-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20movie%20still%2C%20rain-soaked%20neon-lit%20city%20street%20at%20night%20with%20a%20running%20silhouette%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20tense%20composition&width=1280&height=720&seq=movie-backdrop-02&orientation=landscape',
    synopsis:
      '一场连环失踪案让整座城市陷入恐慌，一名执拗的老刑警与年轻的犯罪心理学家联手追查。随着线索逐渐浮现，他们发现真相比想象中更加危险，也更加接近自己。',
    featured: true,
    popularity: 95,
  },
  {
    id: '3',
    title: '春日情书',
    titleEn: 'Spring Letter',
    subtitle: '那些没能说出口的话，都写在信里',
    category: '爱情片',
    genres: ['爱情', '剧情'],
    year: 2024,
    region: '日本',
    rating: 8.7,
    duration: 118,
    director: '佐藤悠介',
    cast: ['新垣绫', '山田凉', '松本琴音', '高桥圭'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20two%20silhouettes%20standing%20under%20cherry%20blossom%20trees%20at%20golden%20hour%2C%20dreamy%20soft%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20romantic%20key%20art&width=400&height=600&seq=movie-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20movie%20still%2C%20cherry%20blossom%20trees%20lining%20a%20quiet%20path%20at%20golden%20hour%20with%20two%20walking%20figures%2C%20soft%20dreamy%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20tender%20composition&width=1280&height=720&seq=movie-backdrop-03&orientation=landscape',
    synopsis:
      '一封尘封多年的情书，把两个早已走向不同人生的人重新牵到一起。在樱花纷飞的季节里，他们翻开过去，也重新面对那些年被刻意遗忘的心意。',
    featured: true,
    popularity: 90,
  },
  {
    id: '4',
    title: '疯狂周末',
    titleEn: 'Crazy Weekend',
    subtitle: '计划永远赶不上变化',
    category: '喜剧片',
    genres: ['喜剧', '家庭'],
    year: 2025,
    region: '中国大陆',
    rating: 7.6,
    duration: 104,
    director: '王小乐',
    cast: ['沈腾飞', '马丽娜', '常远', '魏翔'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20movie%20poster%2C%20a%20chaotic%20colorful%20living%20room%20party%20scene%20with%20confetti%20and%20happy%20people%2C%20playful%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20fun%20upbeat%20key%20art&width=400&height=600&seq=movie-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20comedy%20movie%20still%2C%20a%20chaotic%20bright%20living%20room%20party%20with%20confetti%20and%20laughing%20friends%2C%20warm%20playful%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20energetic%20composition&width=1280&height=720&seq=movie-backdrop-04&orientation=landscape',
    synopsis:
      '一对小夫妻本想度过一个安静惬意的周末，却因为双方父母、邻居和一只捣乱的宠物，把家变成了大型灾难现场。笑料不断的背后，是中国人最真实的家庭温情。',
    featured: false,
    popularity: 84,
  },
  {
    id: '5',
    title: '深海回声',
    titleEn: 'Echo of the Deep',
    subtitle: '海面之下，藏着人类未知的恐惧',
    category: '悬疑片',
    genres: ['悬疑', '科幻', '惊悚'],
    year: 2026,
    region: '英国',
    rating: 8.3,
    duration: 132,
    director: '詹姆斯·霍顿',
    cast: ['艾拉·史密斯', '陈曦', '大卫·布朗', '李安然'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20deep%20sea%20submarine%20surrounded%20by%20glowing%20bioluminescent%20creatures%20in%20dark%20water%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20suspense%20key%20art&width=400&height=600&seq=movie-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20movie%20still%2C%20a%20deep%20sea%20submarine%20descending%20into%20dark%20abyssal%20water%20with%20glowing%20organisms%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20tense%20composition&width=1280&height=720&seq=movie-backdrop-05&orientation=landscape',
    synopsis:
      '一支深海科考队在马里亚纳海沟接收到一段不可能存在的信号。随着下潜深度不断增加，他们逐渐意识到，真正需要面对的并不是海洋，而是某种一直在等待他们的存在。',
    featured: true,
    popularity: 93,
  },
  {
    id: '6',
    title: '江湖刀客',
    titleEn: 'Blade of Rivers',
    subtitle: '刀出鞘时，恩怨了断',
    category: '动作片',
    genres: ['动作', '武侠', '剧情'],
    year: 2024,
    region: '中国大陆',
    rating: 8.1,
    duration: 126,
    director: '徐克文',
    cast: ['张震霆', '章子枫', '王千源', '刘诗雨'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wuxia%20movie%20poster%2C%20a%20lone%20swordsman%20standing%20on%20a%20misty%20cliff%20at%20dusk%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20epic%20eastern%20key%20art&width=400&height=600&seq=movie-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20wuxia%20movie%20still%2C%20a%20lone%20swordsman%20on%20a%20misty%20mountain%20cliff%20at%20dusk%20with%20floating%20leaves%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20dramatic%20composition&width=1280&height=720&seq=movie-backdrop-06&orientation=landscape',
    synopsis:
      '一把传世名刀，一段血海深仇。隐居多年的刀客被迫重返江湖，在刀光剑影中追查当年灭门真相。当他挥出最后一刀时，才明白真正难以斩断的，是人心。',
    featured: false,
    popularity: 88,
  },
  {
    id: '7',
    title: '时间旅人',
    titleEn: 'The Time Traveler',
    subtitle: '如果能重来一次，你会改变什么',
    category: '科幻片',
    genres: ['科幻', '爱情', '剧情'],
    year: 2023,
    region: '美国',
    rating: 8.6,
    duration: 138,
    director: '大卫·林奇恩',
    cast: ['莱昂·格雷', '周雨彤', '迈克尔·亚当', '苏菲·罗兰'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20movie%20poster%2C%20a%20figure%20walking%20through%20a%20corridor%20of%20swirling%20clock%20gears%20and%20light%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20sci-fi%20movie%20still%2C%20a%20corridor%20of%20swirling%20glowing%20clock%20gears%20with%20a%20walking%20figure%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20surreal%20composition&width=1280&height=720&seq=movie-backdrop-07&orientation=landscape',
    synopsis:
      '一名物理学家意外掌握了穿越时间的能力，一次次回到过去试图拯救挚爱，却发现每一次改变都在制造新的遗憾。他终于明白，有些爱，只能在当下好好珍惜。',
    featured: false,
    popularity: 91,
  },
  {
    id: '8',
    title: '沉默的证人',
    titleEn: 'Silent Witness',
    subtitle: '没有尸体的案件，最难破解',
    category: '悬疑片',
    genres: ['悬疑', '犯罪', '剧情'],
    year: 2025,
    region: '韩国',
    rating: 8.4,
    duration: 121,
    director: '朴镇浩',
    cast: ['崔东旭', '金泰梨', '李到贤', '郑素敏'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20movie%20poster%2C%20a%20dark%20interrogation%20room%20with%20a%20single%20hanging%20lamp%20over%20a%20table%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20suspense%20key%20art&width=400&height=600&seq=movie-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20crime%20movie%20still%2C%20a%20dark%20interrogation%20room%20lit%20by%20a%20single%20hanging%20lamp%20above%20a%20table%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20tense%20composition&width=1280&height=720&seq=movie-backdrop-08&orientation=landscape',
    synopsis:
      '一名法医在一具“不存在”的尸体上发现了决定性线索，从而卷入一桩牵涉多年的悬案。当所有证词都指向同一个人，唯一的沉默证人却道出了惊人的另一面。',
    featured: false,
    popularity: 89,
  },
  {
    id: '9',
    title: '山那边的家',
    titleEn: 'Home Beyond Mountains',
    subtitle: '无论走多远，家都在那里',
    category: '剧情片',
    genres: ['剧情', '家庭', '温情'],
    year: 2024,
    region: '中国大陆',
    rating: 8.8,
    duration: 115,
    director: '李睿珺',
    cast: ['海清', '王砚辉', '张子枫', '黄轩'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20drama%20movie%20poster%2C%20a%20small%20house%20on%20terraced%20green%20mountains%20at%20dawn%20with%20mist%2C%20warm%20soft%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20atmospheric%20key%20art&width=400&height=600&seq=movie-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20drama%20movie%20still%2C%20terraced%20green%20mountains%20at%20dawn%20with%20a%20tiny%20house%20and%20mist%2C%20warm%20soft%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20serene%20composition&width=1280&height=720&seq=movie-backdrop-09&orientation=landscape',
    synopsis:
      '在城市打拼多年的女儿回到山里老家，陪伴年迈的父母度过最后一个农忙季。一饭一蔬、一言一语间，浓缩着中国式家庭最深沉的爱与遗憾。',
    featured: false,
    popularity: 86,
  },
  {
    id: '10',
    title: '爆笑联盟',
    titleEn: 'Laugh Out Loud',
    subtitle: '一群不靠谱的人，干成了一件大事',
    category: '喜剧片',
    genres: ['喜剧', '冒险'],
    year: 2023,
    region: '中国大陆',
    rating: 7.3,
    duration: 99,
    director: '宁浩宇',
    cast: ['黄渤洋', '王宝强', '徐峥', '沈腾飞'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20movie%20poster%2C%20a%20group%20of%20quirky%20friends%20piled%20in%20a%20vintage%20car%20laughing%20on%20a%20road%20trip%2C%20playful%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20fun%20key%20art&width=400&height=600&seq=movie-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20comedy%20movie%20still%2C%20a%20vintage%20car%20full%20of%20laughing%20friends%20on%20a%20desert%20road%20trip%2C%20warm%20playful%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20energetic%20composition&width=1280&height=720&seq=movie-backdrop-10&orientation=landscape',
    synopsis:
      '五个走投无路的小人物，为了一个荒唐的梦想凑到一起，踏上了一场状况百出的公路冒险。笑料密集的旅程背后，是平凡人也能闪闪发光的勇气。',
    featured: false,
    popularity: 80,
  },
  {
    id: '11',
    title: '星海征途',
    titleEn: 'Voyage of the Stars',
    subtitle: '人类的征途，是星辰大海',
    category: '科幻片',
    genres: ['科幻', '冒险', '史诗'],
    year: 2026,
    region: '美国',
    rating: 9.1,
    duration: 155,
    director: '丹尼斯·维伦',
    cast: ['蒂莫西·李', '赞达亚·陈', '奥斯卡·王', '丽贝卡·冯'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20epic%20sci-fi%20movie%20poster%2C%20a%20majestic%20fleet%20of%20starships%20crossing%20a%20colorful%20nebula%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20epic%20key%20art&width=400&height=600&seq=movie-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20epic%20sci-fi%20movie%20still%2C%20a%20majestic%20fleet%20of%20starships%20crossing%20a%20vast%20glowing%20nebula%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20epic%20composition&width=1280&height=720&seq=movie-backdrop-11&orientation=landscape',
    synopsis:
      '在资源枯竭的未来，人类组建了史上最大规模的星际舰队，驶向遥远的宜居星球。跨越百年的航程中，舰队不仅要面对宇宙的凶险，也要面对人性本身的考验。',
    featured: true,
    popularity: 99,
  },
  {
    id: '12',
    title: '午夜出租车',
    titleEn: 'Midnight Taxi',
    subtitle: '坐上车，就再也下不来了',
    category: '惊悚片',
    genres: ['惊悚', '悬疑'],
    year: 2024,
    region: '中国香港',
    rating: 7.8,
    duration: 106,
    director: '彭顺',
    cast: ['张家辉', '杨颖', '任达华', '文咏珊'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20thriller%20movie%20poster%2C%20a%20lone%20taxi%20on%20an%20empty%20foggy%20city%20street%20under%20one%20glowing%20streetlight%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20eerie%20key%20art&width=400&height=600&seq=movie-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20thriller%20movie%20still%2C%20a%20lone%20taxi%20parked%20on%20an%20empty%20foggy%20city%20street%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20eerie%20composition&width=1280&height=720&seq=movie-backdrop-12&orientation=landscape',
    synopsis:
      '一名夜班出租车司机接到一位神秘乘客，前往一个地图上不存在的地方。随着夜色加深，车窗外的世界越来越陌生，而这位乘客的目的，远比他想象的更加可怕。',
    featured: false,
    popularity: 82,
  },
  {
    id: '13',
    title: '你好，旧时光',
    titleEn: 'Hello, Old Times',
    subtitle: '青春里最好的我们',
    category: '爱情片',
    genres: ['爱情', '青春', '剧情'],
    year: 2022,
    region: '中国大陆',
    rating: 8.2,
    duration: 112,
    director: '沙漠',
    cast: ['张新成', '李兰迪', '周澄奥', '李牵'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20coming-of-age%20movie%20poster%2C%20a%20nostalgic%20school%20hallway%20with%20warm%20sunlight%20and%20two%20students%20walking%2C%20soft%20romantic%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20coming-of-age%20movie%20still%2C%20a%20sunlit%20school%20hallway%20with%20two%20walking%20students%20and%20dust%20in%20the%20air%2C%20warm%20nostalgic%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20tender%20composition&width=1280&height=720&seq=movie-backdrop-13&orientation=landscape',
    synopsis:
      '高中教室里的一场暗恋，延续到多年后的重逢。当年那个总坐在窗边的少年与爱写日记的女孩，终于在成年后的世界里，读懂了彼此青春里没说出口的心事。',
    featured: false,
    popularity: 83,
  },
  {
    id: '14',
    title: '铁血战士',
    titleEn: 'Iron Blood',
    subtitle: '战场上，没有退路',
    category: '动作片',
    genres: ['动作', '战争', '剧情'],
    year: 2023,
    region: '美国',
    rating: 8.0,
    duration: 130,
    director: '萨姆·门德斯',
    cast: ['克里斯·海姆斯', '陈国坤', '马克·沃伯格', '艾米·亚当'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20war%20movie%20poster%2C%20a%20battle-worn%20soldier%20standing%20in%20a%20ruined%20warzone%20at%20dawn%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20gritty%20key%20art&width=400&height=600&seq=movie-poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20war%20movie%20still%2C%20a%20battle-worn%20soldier%20walking%20through%20a%20ruined%20smoking%20warzone%20at%20dawn%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20gritty%20composition&width=1280&height=720&seq=movie-backdrop-14&orientation=landscape',
    synopsis:
      '一支深入敌后的精英小队，在执行一次几乎不可能完成的任务时，被迫直面战争的残酷与人性的抉择。当命令与良心冲突，他们必须选择自己真正要守护的东西。',
    featured: false,
    popularity: 81,
  },
  {
    id: '15',
    title: '追风少年',
    titleEn: 'Chasing the Wind',
    subtitle: '只要还在骑，就还有希望',
    category: '剧情片',
    genres: ['剧情', '运动', '励志'],
    year: 2025,
    region: '中国大陆',
    rating: 8.3,
    duration: 108,
    director: '陈可辛',
    cast: ['易烊千玺', '王俊凯', '张子枫', '刘昊然'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sports%20drama%20movie%20poster%2C%20a%20young%20cyclist%20racing%20along%20a%20coastal%20road%20at%20sunrise%2C%20energetic%20warm%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20inspiring%20key%20art&width=400&height=600&seq=movie-poster-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20sports%20drama%20movie%20still%2C%20young%20cyclists%20racing%20along%20a%20coastal%20road%20at%20sunrise%20with%20sea%20spray%2C%20energetic%20warm%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20dynamic%20composition&width=1280&height=720&seq=movie-backdrop-15&orientation=landscape',
    synopsis:
      '一个来自小城的少年，为了心中的骑行梦想，独自来到大城市参加职业选拔。在一次次跌倒与质疑中，他用双脚踩出了属于自己的路，也证明了热爱从不廉价。',
    featured: false,
    popularity: 87,
  },
  {
    id: '16',
    title: '迷雾之城',
    titleEn: 'City of Mist',
    subtitle: '真相被雾掩盖，也会被光揭开',
    category: '悬疑片',
    genres: ['悬疑', '犯罪', '剧情'],
    year: 2024,
    region: '中国大陆',
    rating: 8.6,
    duration: 124,
    director: '曹保平',
    cast: ['段奕宏', '周迅', '廖凡', '谭卓'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20movie%20poster%2C%20a%20detective%20silhouette%20standing%20on%20a%20rooftop%20above%20a%20misty%20city%20skyline%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20moody%20key%20art&width=400&height=600&seq=movie-poster-16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20mystery%20movie%20still%2C%20a%20detective%20silhouette%20on%20a%20rooftop%20above%20a%20misty%20glowing%20city%20skyline%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20tense%20composition&width=1280&height=720&seq=movie-backdrop-16&orientation=landscape',
    synopsis:
      '在一座常年被浓雾笼罩的城市里，连续发生的离奇案件让警方束手无策。一位固执的老刑警凭借残缺的线索，一步步走进迷雾中心，也走进了自己尘封多年的秘密。',
    featured: true,
    popularity: 92,
  },
  {
    id: '17',
    title: '欢乐一家亲',
    titleEn: 'Happy Family',
    subtitle: '吵吵闹闹，才是最真的幸福',
    category: '喜剧片',
    genres: ['喜剧', '家庭', '温情'],
    year: 2023,
    region: '中国大陆',
    rating: 7.5,
    duration: 101,
    director: '冯小刚',
    cast: ['葛优', '闫妮', '雷佳音', '马丽娜'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20family%20comedy%20movie%20poster%2C%20a%20warm%20family%20dinner%20table%20scene%20with%20laughing%20relatives%20and%20steaming%20dishes%2C%20cozy%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20hearty%20key%20art&width=400&height=600&seq=movie-poster-17&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20family%20comedy%20movie%20still%2C%20a%20warm%20family%20dinner%20table%20with%20laughing%20relatives%20and%20steaming%20dishes%2C%20cozy%20warm%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20heartwarming%20composition&width=1280&height=720&seq=movie-backdrop-17&orientation=landscape',
    synopsis:
      '一个三代同堂的大家庭，因为一次意外的相聚，把平日里藏着掖着的矛盾全都摆上了饭桌。鸡飞狗跳之间，每个人都重新学会了如何好好爱身边的人。',
    featured: false,
    popularity: 78,
  },
  {
    id: '18',
    title: '极地救援',
    titleEn: 'Polar Rescue',
    subtitle: '在最冷的地方，见证最暖的人心',
    category: '冒险片',
    genres: ['冒险', '灾难', '剧情'],
    year: 2025,
    region: '英国',
    rating: 8.4,
    duration: 134,
    director: '克里斯托弗·诺兰',
    cast: ['汤姆·哈迪', '陈数', '本尼迪·康伯', '凯拉·奈特'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20adventure%20movie%20poster%2C%20a%20rescue%20team%20crossing%20an%20arctic%20ice%20field%20in%20a%20blizzard%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20epic%20key%20art&width=400&height=600&seq=movie-poster-18&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20adventure%20movie%20still%2C%20a%20rescue%20team%20crossing%20a%20vast%20arctic%20ice%20field%20in%20a%20blizzard%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20epic%20composition&width=1280&height=720&seq=movie-backdrop-18&orientation=landscape',
    synopsis:
      '一场突如其来的极地风暴，让一支科考队与外界彻底失联。一支临时组建的救援队，必须在有限的时间内穿越冰原，去拯救那些也许已无法生还的同伴。',
    featured: false,
    popularity: 85,
  },
  {
    id: '19',
    title: '幻境之城',
    titleEn: 'Dream City',
    subtitle: '梦醒之后，你还记得谁',
    category: '奇幻片',
    genres: ['奇幻', '冒险', '剧情'],
    year: 2026,
    region: '日本',
    rating: 8.7,
    duration: 128,
    director: '新海诚',
    cast: ['神木隆之介', '桥本环奈', '菅田将晖', '吉冈里帆'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20fantasy%20anime%20movie%20poster%2C%20a%20floating%20surreal%20city%20with%20waterfalls%20and%20glowing%20lanterns%2C%20dreamy%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20magical%20key%20art&width=400&height=600&seq=movie-poster-19&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20fantasy%20movie%20still%2C%20a%20floating%20surreal%20city%20with%20waterfalls%20and%20thousands%20of%20glowing%20lanterns%2C%20dreamy%20magical%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20breathtaking%20composition&width=1280&height=720&seq=movie-backdrop-19&orientation=landscape',
    synopsis:
      '一名平凡的少女在梦中一次次来到一座漂浮的城市，那里有会说话的动物和永不熄灭的灯火。当她发现梦境正在侵蚀现实，她必须在遗忘与记得之间，做出一个艰难的抉择。',
    featured: true,
    popularity: 94,
  },
  {
    id: '20',
    title: '最后一班地铁',
    titleEn: 'The Last Metro',
    subtitle: '末班车上，每个人都有故事',
    category: '剧情片',
    genres: ['剧情', '文艺'],
    year: 2022,
    region: '法国',
    rating: 8.1,
    duration: 110,
    director: '吕克·贝松',
    cast: ['蕾雅·赛杜', '文森特·卡索', '陈默', '玛丽昂·歌迪'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20arthouse%20movie%20poster%2C%20an%20empty%20metro%20platform%20with%20the%20last%20train%20arriving%20at%20night%20under%20warm%20lights%2C%20moody%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-20&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20arthouse%20movie%20still%2C%20an%20empty%20metro%20platform%20at%20night%20with%20the%20last%20train%20arriving%20under%20warm%20lights%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20quiet%20composition&width=1280&height=720&seq=movie-backdrop-20&orientation=landscape',
    synopsis:
      '午夜的最后班地铁上，六个素不相识的乘客因为一场意外被困车厢。他们各自怀揣着秘密与遗憾，在漫长的等待里，交换着彼此人生中最真实的一段故事。',
    featured: false,
    popularity: 76,
  },
  {
    id: '21',
    title: '龙之觉醒',
    titleEn: 'Dragon Awakening',
    subtitle: '当古老的誓言再次响起',
    category: '奇幻片',
    genres: ['奇幻', '冒险', '史诗'],
    year: 2025,
    region: '美国',
    rating: 8.5,
    duration: 142,
    director: '彼得·杰克逊',
    cast: ['亨利·卡维', '刘亦菲', '伊恩·麦克', '佛罗伦斯·珀'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20epic%20fantasy%20movie%20poster%2C%20a%20colossal%20dragon%20rising%20above%20a%20mountain%20temple%20at%20dusk%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20epic%20key%20art&width=400&height=600&seq=movie-poster-21&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20epic%20fantasy%20movie%20still%2C%20a%20colossal%20dragon%20flying%20above%20a%20misty%20mountain%20temple%20at%20dusk%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20epic%20composition&width=1280&height=720&seq=movie-backdrop-21&orientation=landscape',
    synopsis:
      '沉睡千年的巨龙在一个即将被战火吞没的王国上空苏醒。一位背负家族使命的年轻守龙人，必须集结起散落各方的伙伴，去唤醒世界上最后的力量。',
    featured: false,
    popularity: 88,
  },
  {
    id: '22',
    title: '红色警报',
    titleEn: 'Red Alert',
    subtitle: '灾难来临前，只有倒计时',
    category: '动作片',
    genres: ['动作', '灾难', '惊悚'],
    year: 2024,
    region: '美国',
    rating: 7.9,
    duration: 118,
    director: '迈克尔·贝',
    cast: ['道恩·强森', '张静初', '杰森·斯坦森', '盖尔·加朵'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20movie%20poster%2C%20a%20helicopter%20over%20a%20city%20with%20red%20warning%20lights%20and%20rising%20smoke%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20intense%20key%20art&width=400&height=600&seq=movie-poster-22&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20action%20movie%20still%2C%20a%20helicopter%20flying%20over%20a%20city%20with%20red%20warning%20lights%20and%20rising%20smoke%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20intense%20composition&width=1280&height=720&seq=movie-backdrop-22&orientation=landscape',
    synopsis:
      '一场席卷全城的能源危机，让整座城市陷入红色警报。一名退役的特种兵临危受命，必须在灾难彻底爆发之前，找到幕后真正的黑手，拯救数百万人的性命。',
    featured: false,
    popularity: 80,
  },
  {
    id: '23',
    title: '星际迷航者',
    titleEn: 'Star Wanderer',
    subtitle: '在无边的宇宙里，寻找归途',
    category: '科幻片',
    genres: ['科幻', '冒险'],
    year: 2023,
    region: '美国',
    rating: 8.2,
    duration: 136,
    director: 'J·J·艾布拉姆斯',
    cast: ['克里斯·派恩', '周迅', '扎克瑞·昆图', '佐伊·索尔达娜'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20sci-fi%20movie%20poster%2C%20a%20small%20spacecraft%20drifting%20near%20a%20giant%20ringed%20planet%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-23&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20sci-fi%20movie%20still%2C%20a%20small%20spacecraft%20drifting%20near%20a%20giant%20glowing%20ringed%20planet%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20epic%20composition&width=1280&height=720&seq=movie-backdrop-23&orientation=landscape',
    synopsis:
      '一艘迷航的探索舰在宇宙深处失去坐标，船员们只能在陌生的星系间艰难求生。当他们终于等到回家的信号，却发现自己早已与出发的那个世界，隔了整整一个时代。',
    featured: false,
    popularity: 79,
  },
  {
    id: '24',
    title: '雪国列车',
    titleEn: 'Snowland Train',
    subtitle: '开往冬天的列车，载着整个世界的余温',
    category: '剧情片',
    genres: ['剧情', '科幻', '灾难'],
    year: 2021,
    region: '韩国',
    rating: 8.3,
    duration: 126,
    director: '奉俊昊',
    cast: ['宋康昊', '蒂尔达·斯文顿', '李善均', '克里斯·埃文斯'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20dystopian%20movie%20poster%2C%20a%20vintage%20train%20crossing%20a%20snow-covered%20forest%20at%20twilight%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20midnight-blue%20and%20charcoal%20background%20with%20warm%20orange%20glow%20accent%2C%20film%20grain%2C%20ultra%20detailed%20moody%20key%20art&width=400&height=600&seq=movie-poster-24&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20dystopian%20movie%20still%2C%20a%20vintage%20train%20crossing%20an%20endless%20snow-covered%20frozen%20landscape%20at%20twilight%2C%20moody%20atmospheric%20lighting%2C%20deep%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20rim%20light%2C%20film%20grain%2C%20epic%20composition&width=1280&height=720&seq=movie-backdrop-24&orientation=landscape',
    synopsis:
      '在一场永恒的严寒中，幸存的人类挤在一列永不停歇的列车上。车厢之间的等级森严，而车尾的乘客决定推翻这一切，一直走到车头，去看看驱动世界的真相。',
    featured: false,
    popularity: 86,
  },
];